import { CartAddEvent } from '@theme/events';

class CustomBundleSelector extends HTMLElement {
  constructor() {
    super();
    this.quantity = parseInt(this.dataset.quantity);
    this.discount = parseFloat(this.dataset.discount);
    this.selectedVariants = new Array(this.quantity).fill(null);
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.querySelectorAll('.custom-bundle__swatch').forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        const selectorIndex = parseInt(e.currentTarget.dataset.selector);
        const variantId = e.currentTarget.dataset.variantId;
        const variantTitle = e.currentTarget.dataset.variantTitle;
        this.handleSwatchClick(selectorIndex, variantId, variantTitle, e.currentTarget);
      });
    });

    const button = this.querySelector('.custom-bundle__button');
    if (button) {
      button.addEventListener('click', () => {
        if (!button.disabled) {
          this.addToCart();
        }
      });
    }
  }

  handleSwatchClick(selectorIndex, variantId, variantTitle, swatchElement) {
    this.selectedVariants[selectorIndex] = {
      id: variantId,
      title: variantTitle
    };

    const selector = this.querySelector(`.custom-bundle__selector[data-selector="${selectorIndex}"]`);
    if (selector) {
      const label = selector.querySelector('.custom-bundle__selector-label');
      if (label) {
        label.textContent = `Tom: ${variantTitle}`;
      }
    }

    const allSwatchesInSelector = this.querySelectorAll(`.custom-bundle__swatch[data-selector="${selectorIndex}"]`);
    allSwatchesInSelector.forEach(swatch => {
      swatch.classList.remove('selected');
    });
    swatchElement.classList.add('selected');

    this.updateButton();
  }

  updateButton() {
    const button = this.querySelector('.custom-bundle__button');
    if (!button) return;

    const allSelected = this.selectedVariants.every(v => v !== null);

    if (allSelected) {
      button.disabled = false;
      button.textContent = 'ADICIONAR À SACOLA';
    } else {
      button.disabled = true;
      button.textContent = 'SELECIONE O TOM';
    }
  }

  async addToCart() {
    const button = this.querySelector('.custom-bundle__button');

    const items = this.selectedVariants.map(variant => ({
      id: parseInt(variant.id),
      quantity: 1
    }));

    const formData = new FormData();

    items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
    });

    try {
      button.disabled = true;
      button.textContent = 'ADICIONANDO...';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Erro na requisição');
      }

      const responseData = await response.json();

      if (responseData.status || responseData.description) {
        throw new Error(responseData.description || responseData.message || 'Erro ao adicionar ao carrinho');
      }

      // Busca o carrinho atualizado para obter o item_count e demais dados completos
      let cart = null;
      try {
        const cartResponse = await fetch('/cart.js');
        cart = await cartResponse.json();
      } catch (cartError) {
        console.error('Erro ao buscar o carrinho atualizado:', cartError);
      }

      // Dispara o evento nativo do tema para abrir o cart-drawer e atualizar
      // o ícone do carrinho e a lista de itens automaticamente.
      this.dispatchEvent(
        new CartAddEvent(cart ?? undefined, this.id || 'custom-bundle-selector', {
          source: 'custom-bundle',
          itemCount: items.reduce((total, item) => total + item.quantity, 0),
          sections: responseData.sections,
        })
      );

      button.textContent = '✓ ADICIONADO!';
      button.style.backgroundColor = 'green';

      setTimeout(() => {
        button.textContent = 'ADICIONAR À SACOLA';
        button.style.backgroundColor = '';
        button.disabled = false;
      }, 2000);

    } catch (error) {
      console.error('Erro ao adicionar bundle ao carrinho:', error);
      button.textContent = 'ERRO - TENTE NOVAMENTE';
      button.style.backgroundColor = 'red';

      setTimeout(() => {
        button.textContent = 'ADICIONAR À SACOLA';
        button.style.backgroundColor = '';
        button.disabled = false;
      }, 3000);
    }
  }
}

customElements.define('custom-bundle-selector', CustomBundleSelector);
